import Api from './api';

const slug = 'v1/documents';
export default {
  createDocument(document) {
    return new Promise((resolve, reject) => {
      Api.post(`/${slug}/`, document)
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  getDocuments(params) {
    return new Promise((resolve, reject) => {
      Api.get(`/${slug}/`, { params })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getDocument(documentId) {
    return new Promise((resolve, reject) => {
      Api.get(`/${slug}/${documentId}`, {})
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updateDocument(document) {
    return new Promise((resolve, reject) => {
      Api.post(`/${slug}/update/${document._id}`, document)
        .then(res => resolve(res.data[0]))
        .catch((err) => {
          reject(err);
        });
    });
  },
  deleteDocument(document) {
    return new Promise((resolve, reject) => {
      Api.delete(`/${slug}/${document._id}`)
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
};
